import * as Yup from "yup";

export const province = {
  create: Yup.object().shape({
    isCapital: Yup.boolean().typeError('مقدار باید درست یا غلط باشد'),
    key: Yup.string().typeError('کلید باید رشته باشد'),
    name: Yup.string().required('نام الزامی است'),
    prefix: Yup.string().typeError('پیشوند باید رشته باشد'),
    latitude: Yup.string().typeError('عرض جغرافیایی باید رشته باشد'),
    longitude: Yup.string().typeError('طول جغرافیایی باید رشته باشد'),
    description: Yup.string().typeError('توضیحات باید رشته باشد'),
    code: Yup.number()
      .integer('کد باید عدد صحیح باشد')
      .positive('کد باید عدد مثبت باشد')
      .typeError('کد باید عدد باشد'),
    population: Yup.number()
      .integer('جمعیت باید عدد صحیح باشد')
      .positive('جمعیت باید عدد مثبت باشد')
      .typeError('جمعیت باید عدد باشد'),
    coords: Yup.array()
      .of(
        Yup.array().of(
          Yup.number().required('مختصات باید عدد باشد')
        )
      )
      .typeError('مختصات باید آرایه‌ای از اعداد باشد'),
  })
}

;
